import { useMemo } from 'react';

import { useGetActivitySections } from 'approot/activity-builder/activity-builder-section.hooks';
import {
  ACTIVITIES_COMPONENT_TYPE_ACTIVITY,
  ActivitiesContentType,
} from 'global/constants';
import {
  getResponseComponentsFromSection,
  getResponseComponentsFromSubSection,
  filterOutReadOnlyTable,
} from '../suggested-answer.utils';
import { hasAnswerData } from './suggested-answer-view.utils';
import { Differentiation } from 'approot/shared/differentiation/differentiation.constants';
import { ComponentActivity } from '../../component.constants';

export const useGetResponseComponents = ({
  contentType,
  contentId,
  classId,
  currentSectionId,
  urlSectionId,
  isPublic,
  version,
}: {
  contentType: ActivitiesContentType;
  contentId: number;
  classId: number | null;
  currentSectionId: string;
  urlSectionId?: string;
  isPublic?: boolean;
  version?: string | null;
}) => {
  const { data: sectionData } = useGetActivitySections({
    classId,
    contentId,
    contentType,
    version,
    isPublic,
    sectionIds: [currentSectionId],
  });

  const activityComponent = useMemo(() => {
    return sectionData?.getActivitiesSections?.[0]?.components.find(
      c => c.type === ACTIVITIES_COMPONENT_TYPE_ACTIVITY
    ) as ComponentActivity | undefined;
  }, [sectionData]);

  const responseComponents = useMemo(() => {
    return filterOutReadOnlyTable(
      currentSectionId !== urlSectionId && urlSectionId
        ? getResponseComponentsFromSubSection(urlSectionId, sectionData)
        : getResponseComponentsFromSection(sectionData)
    );
  }, [currentSectionId, urlSectionId, sectionData]);

  const hasAnswers = useMemo(
    () => hasAnswerData(responseComponents),
    [responseComponents]
  );

  return {
    responseComponents,
    hasAnswers,
    isUnitQuiz:
      activityComponent?.properties?.activitySettings?.differentiation ===
      Differentiation.UnitQuiz,
  };
};
